module.exports = {
          srcSet: __webpack_public_path__ + "ca9aaeeb409494efc6b4110ebe27f772-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "ca9aaeeb409494efc6b4110ebe27f772-2336.png",width: 2336,height: 496}],
          src: __webpack_public_path__ + "ca9aaeeb409494efc6b4110ebe27f772-2336.png",
          toString:function(){return __webpack_public_path__ + "ca9aaeeb409494efc6b4110ebe27f772-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/ABlQNvwsZkr+K25O/SNvSv0HYzf9C2Q5/T58W/0AUiz9W1dB/i9RM/oAECwf/BYyJf4OLR7+EjEi/g4wIf4SKBr+dzk7/jpMQv6dNjv/u2Bc+1CqIfqIVNKiAAAAAElFTkSuQmCC",
          width: 2336,
          height: 496
        }